import React, {Component} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {Map} from "immutable";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";


// Components
import EmployeeDetail from "./EmployeeDetail";
import EmployeeWorkReports from './EmployeeWorkReports';
import EmployeeFiles from './EmployeeFiles';
import DeleteDialog from '../../components/dialogs/DeleteDialog';

// Actions
import {getEmployee, changeEmployeeStatus, updateEmployee, deleteEmployeeFile, downloadEmployeeFile, uploadEmployeeFiles, deleteEmployee, cleanEmployees} from "../../actions/employees";

class EmployeeTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: this.getSelectedIndex(),
            mode: 'view',
            canSubmit: false,
            // modal
            modalIsOpen: false,
            modalType: null
        };

        this.getSelectedIndex = this.getSelectedIndex.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    componentDidMount() {
        this.props.getEmployee(this.props.match.params.employeeId);
    }

    componentWillUnmount() {
        this.props.cleanEmployees();
    }

    // Tab functions
    getSelectedIndex() {
        const {employeeId} = this.props.match.params;

        // Check if any child route is active. As last step, check if principal route is active to assign default tab index.
        switch (this.props.history.location.pathname) {
            case '/empleados/' + employeeId + '/detalle':
                return 0;
            case '/empleados/' + employeeId + '/registro':
                return 1;
            case '/empleados/' + employeeId + '/ficheros':
                return 2;
            default:
                return 0;
        }
    }
    handleTabChange(index, lastIndex, event) {
        const {employeeId} = this.props.match.params;
        let route = '';

        switch (index) {
            case 0:
                route = '/empleados/' + employeeId + '/detalle';
                break;
            case 1:
                route = '/empleados/' + employeeId + '/registro';
                break;
            case 2:
                route = '/empleados/' + employeeId + '/ficheros';
                break;
            default:
                break;
        }

        this.props.history.push(route);
        this.setState({
            tabIndex: this.getSelectedIndex()
        });
    }

    // EmployeeDetail functions
    handleEditClick = () => {
        this.setState({
            mode: 'edit'
        });
    };
    handleCancelClick = () => {
        this.child.updateEmployeesState();
        this.setState({
            mode: 'view',
            canSubmit: false
        });
    };
    handleSaveClick = () => {
        this.child.updateEmployee();
        this.setState({
            mode: 'view',
            canSubmit: false
        });
    };

    canSubmit = (canSubmit) => {
        this.setState({ canSubmit })
    };

    // Modal handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false
        })
    };

    render() {
        const { tabIndex, mode, canSubmit } = this.state;

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'deleteDialog':
                    modal = {
                        width: 'medium',
                        title: 'Borrar empleado',
                        body: (
                            <DeleteDialog
                                text={ this.props.employee.get('employee_code') }
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="delete"
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={ () => {
                                        this.props.deleteEmployee(this.props.employee.get('_id'));
                                        this.closeModal();
                                        this.props.history.push('/empleados');
                                    }}
                                >
                                    {'Borrar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }


        return (

            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/empleados">Empleados</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>{`[${this.props.employee.get('employee_code') || ''}] ${this.props.employee.get('name') || ''} ${this.props.employee.get('last_name') || ''}`}</strong>
                            </li>
                        </ol>
                    </div>
                    { tabIndex === 0
                        ? (
                            <div className="col d-flex align-items-center justify-content-end">
                                {mode === 'view'
                                    ? <div className="title-action">
                                        { this.props.employee.get('can_delete')
                                            ? <button className="btn btn-danger" onClick={ () => this.openModal('deleteDialog') }>Borrar</button>
                                            : null
                                        }
                                        <button className="btn btn-custom" onClick={this.handleEditClick}>Editar</button>
                                    </div>
                                    : <div className="title-action">
                                        <button className="btn btn-cancel" onClick={this.handleCancelClick}>Cancelar</button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.handleSaveClick}
                                            disabled={!canSubmit}
                                        >Guardar
                                        </button>
                                    </div>
                                }
                            </div>
                        ) : ''
                    }
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="tabs-container">
                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={this.handleTabChange}
                                    selectedTabPanelClassName="active show"
                                >
                                    <TabList className="nav nav-tabs">
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 0})}>Detalle</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 1})}>Registros de trabajo</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 2})}>Ficheros</Link>
                                        </Tab>
                                    </TabList>
                                    <div className="tab-content">
                                        <TabPanel className="tab-pane">
                                            { this.props.employee.get('_id')
                                                ? <EmployeeDetail
                                                    onRef={ref => (this.child = ref)}
                                                    mode={this.state.mode}
                                                    canSubmit={this.canSubmit}
                                                    employee={this.props.employee}
                                                    updateEmployee={this.props.updateEmployee}
                                                    changeEmployeeStatus={this.props.changeEmployeeStatus}
                                                />
                                                : null
                                            }
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            { this.props.employee.get('_id')
                                                ? <EmployeeWorkReports
                                                    employee={this.props.employee}
                                                    location={this.props.location}
                                                />
                                                : null
                                            }
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            { this.props.employee.get('_id')
                                                ? <EmployeeFiles
                                                    employee={this.props.employee}
                                                    uploadEmployeeFiles={this.props.uploadEmployeeFiles}
                                                    uploadProgress={this.props.uploadProgress}
                                                    downloadEmployeeFile={this.props.downloadEmployeeFile}
                                                    deleteEmployeeFile={this.props.deleteEmployeeFile}
                                                    addNotification={this.props.addNotification}
                                                /> : null
                                            }
                                        </TabPanel>
                                    </div>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const employeeReducer = state.employees;

    // Employee
    let employee = employeeReducer.get('payload') || Map({});
    if (!(employee instanceof Map)) employee = Map({});

    // Upload Progress
    const uploadProgress = Map({
        isUploading: employeeReducer.get('isUploading') || false,
        percent: employeeReducer.get('percent') || 0
    });

    return {
        employee,
        uploadProgress
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getEmployee: (employeeId) => dispatch(getEmployee(employeeId)),
        updateEmployee: (employeeId, employee) => dispatch(updateEmployee(employeeId, employee)),
        changeEmployeeStatus: (employeeId, status) => dispatch(changeEmployeeStatus(employeeId, status)),
        uploadEmployeeFiles: (customerId, files) => dispatch(uploadEmployeeFiles(customerId, files)),
        downloadEmployeeFile: (customerId, fileId) => dispatch(downloadEmployeeFile(customerId, fileId)),
        deleteEmployeeFile: (customerId, fileId) => dispatch(deleteEmployeeFile(customerId, fileId)),
        deleteEmployee: employeeId => dispatch(deleteEmployee(employeeId)),
        cleanEmployees: () => dispatch(cleanEmployees())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeTabs);



// WEBPACK FOOTER //
// ./src/containers/employees/EmployeeTabs.js